import { Form } from 'factorial-form'

import { jobTitleField, salaryFields } from 'modules/contracts/lib/checkFieldVisibility'
import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type ContractVersionPayrollPolicy from 'modules/contracts/store/models/ContractVersionPayrollPolicy'
import type Employee from 'modules/employees/store/models/Employee'
import { contractVersionJobLevel } from 'modules/job_catalog/store/collections/levels'
import { jobLevelRole } from 'modules/job_catalog/store/collections/roles'
import type { PolicyAuthorizations } from 'modules/permissions/store/collections/policyAuthorizations'

const contractVersionToFormValues = (
  contractVersion: ContractVersion | undefined,
  contractVersionPolicy: ContractVersionPayrollPolicy | null
) => {
  const jobLevel = contractVersion ? contractVersionJobLevel(contractVersion) : null

  return {
    id: contractVersion?.id,
    effective_on: null,
    es_job_description: contractVersion?.attributes.es_job_description,
    job_catalog_level_id: jobLevel?.attributes.id,
    job_catalog_role_id: jobLevel ? jobLevelRole(jobLevel)?.attributes.id : null,
    // TODO: Add the job catalog tree node uuid to the form values
    // once we have it in the contract version
    job_catalog_tree_node_uuid: '',
    job_title: contractVersion?.attributes.job_title,
    salary_amount: contractVersion?.attributes.salary_amount,
    salary_frequency: contractVersion?.attributes.salary_frequency,
    payroll_policy_id: contractVersionPolicy?.attributes.payroll_policy_id,
  }
}

export const getPromoteFlowForm = (
  contractVersion: ContractVersion | undefined,
  employee: Employee,
  contractVersionPolicy: ContractVersionPayrollPolicy | null,
  policyAuthorizations: PolicyAuthorizations
): Form => {
  const canSeeJobTitle: boolean = policyAuthorizations.for('contracts.see_job_title', employee)
  const canSeeGrossSalary: boolean = policyAuthorizations.for(
    'contracts.see_gross_salary',
    employee
  )

  return new Form(
    {
      ...contractVersionToFormValues(contractVersion, contractVersionPolicy),
    },
    {
      ...jobTitleField(canSeeJobTitle),
      id: 'number',
      effective_on: 'date',
      es_job_description: 'string',
      job_catalog_level_id: 'number',
      job_catalog_role_id: 'number',
      job_catalog_tree_node_uuid: 'string',
      payroll_policy_id: 'number',
      ...salaryFields(canSeeGrossSalary),
    }
  )
}
